// Helpers for Arive-managed loan files (ticket 134 P1). The server decides
// what is locked and what money the user may see; nothing here checks roles.
import React from 'react';
import { toast } from '../hooks/use-toast';
import AriveBadge from './board/AriveBadge';

export const isAriveManaged = (loan) => !!loan?.arive;

// The "Open in Arive" link lives on the external ref; the mirror is the fallback.
export const ariveDeepLink = (loan) => {
  const ref = (loan?.external_refs || []).find((r) => r.system === 'arive' && (r.status || 'active') === 'active');
  return ref?.deep_link || loan?.arive?.deep_link || null;
};

// 409 {code: "arive_managed", message, fields, edit_url} -> that detail, else null.
export const ariveConflict = (e) => {
  const d = e?.response?.data?.detail;
  return e?.response?.status === 409 && d && typeof d === 'object' && d.code === 'arive_managed' ? d : null;
};

// Toast the conflict and return true; return false for any other error so the
// caller keeps its own handling.
export function toastAriveConflict(e) {
  const d = ariveConflict(e);
  if (!d) return false;
  const fields = (d.fields || []).map((f) => f.replace(/_/g, ' ')).join(', ');
  toast({
    variant: 'blocked',
    title: d.message || 'Managed in Arive',
    description: (
      <span data-testid="arive-conflict-toast">
        {fields ? `Edit ${fields} in Arive. ` : 'Edit this in Arive. '}
        {d.edit_url && (
          <a href={d.edit_url} target="_blank" rel="noopener noreferrer" data-testid="arive-conflict-link" className="underline font-semibold">
            Open in Arive
          </a>
        )}
      </span>
    ),
  });
  return true;
}

// Ticket 192 (D25): on an Arive-linked loan the 1003, fees and loan terms are read-only
// here. The note says so and links to the loan in Arive; the form under it is a
// `<fieldset disabled>` (`display: contents`, so layout is untouched).
export function AriveLockNote({ loan, children, testId = 'arive-lock-note' }) {
  if (!isAriveManaged(loan)) return null;
  return (
    <div className="flex items-center gap-2 text-[12px] text-slate-500" data-testid={testId}>
      <AriveBadge deepLink={ariveDeepLink(loan)} /> {children}
    </div>
  );
}

export function AriveLocked({ loan, children }) {
  return <fieldset disabled={isAriveManaged(loan)} style={{ display: 'contents' }}>{children}</fieldset>;
}
